module.exports = __webpack_public_path__ + "static/ab5-3595181dfcc1a38e106faa3561210837.jpg";